import type { Message } from './types.ts';

export const getMessageId = (message: Message) =>
  encodeURIComponent(JSON.stringify([message.role, message.invocation_id, message.timestamp]));
